import { formatAndBindToJSONToDayjs, getDateRange } from "../../utils"

const dateRangeForMessageFeedback = getDateRange()
const dateRangeForChatHistory = getDateRange({start_date_difference: 0})

const initialState = {
  selectedChat: "",
  chatList: [],
  chatListLoading: false,
  startDate: formatAndBindToJSONToDayjs(dateRangeForChatHistory[0], "start"),
  endDate: formatAndBindToJSONToDayjs(dateRangeForChatHistory[1], "end"),
  searchText: "",
  chatHistoryFilters: {},
  hasMore: false,
  chatlogDetails:[],
  userProfile:{},
  selectedTab: "chatHistory",
  messageFeedbacksFilter:{
    startDate: formatAndBindToJSONToDayjs(dateRangeForMessageFeedback[0], "start"),
    endDate: formatAndBindToJSONToDayjs(dateRangeForMessageFeedback[1], "end"),
    adminActions: ["pending"],
    sources: undefined,
  },
  messageFeedbacks:[],
  totalMessageFeedbacks:0,
}

export default initialState
